import React from "react";

export const RightArrowIcon = (props) => {
  return (
    <>
      <svg
        className={props.className}
        onClick={props?.onClick}
        width="9"
        height="14"
        viewBox="0 0 9 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 1L8 7.05714L1 13"
          stroke="#231F20"
          style={{
            stroke: "#231F20",
            stroke: "color(display-p3 0.1373 0.1216 0.1255)",
            strokeOpacity: 1,
          }}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
